import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type InputProps = InputHTMLAttributes<HTMLInputElement>

export function Input({ className, ...props }: InputProps) {
  return (
    <input
      className={cn(
        'h-11 w-full rounded-xl border border-cream-200 bg-white px-4',
        'text-warm-gray-800 placeholder:text-warm-gray-400',
        'transition-colors duration-150',
        'focus:outline-none focus:ring-2 focus:ring-terracotta-400 focus:ring-offset-1 focus:border-transparent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
      {...props}
    />
  )
}

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      className={cn(
        'min-h-32 w-full rounded-xl border border-cream-200 bg-white px-4 py-3',
        'text-warm-gray-800 placeholder:text-warm-gray-400 resize-none',
        'transition-colors duration-150',
        'focus:outline-none focus:ring-2 focus:ring-terracotta-400 focus:ring-offset-1 focus:border-transparent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
      {...props}
    />
  )
}
